// Detectar automáticamente el entorno
const esLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const RUTA_GLOBAL = esLocal 
    ? "http://localhost/sistema-gimnasio/api/"
    : "https://masterfitadmin.com/api/";

const HttpService = {
    async registrar(datos, ruta){
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
        let resultado = await respuesta.json()
        return resultado
    },

    async obtenerConDatos(datos, ruta){
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
        let resultado = await respuesta.json()
        return resultado
    },


    async obtener(ruta){
        let respuesta = await fetch(RUTA_GLOBAL + ruta)
        let datos = await respuesta.json()
        return datos
    },

    async eliminar(ruta, datos) {
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: "post",
            body: JSON.stringify(datos),
        });
        const texto = await respuesta.text();
        try {
            return JSON.parse(texto);
        } catch (e) {
            console.error('Respuesta no-JSON de', ruta, '->', texto);
            return { __raw: texto, __status: respuesta.status };
        }
    },

    async registrarFormData(datos, ruta) {
        const formData = new FormData();
        for (const key in datos) {
            formData.append(key, datos[key]);
        }
        const respuesta = await fetch(RUTA_GLOBAL + ruta, {
            method: 'POST',
            body: formData
        });
        let resultado = await respuesta.json();
        return resultado;
    }
}

export default  HttpService 


// WEBPACK FOOTER //
// ./src/Servicios/HttpService.js